import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { CoreLogService } from "../../../core/services/log.service";


@Component({
  selector: "sot-loaderdialog",
  templateUrl: "./loaderdialog.component.html",
  styleUrls: ["./loaderdialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderDialogComponent implements OnInit, OnDestroy {

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , public dialogRef: MatDialogRef<LoaderDialogComponent, void>
    , private _coreLogService: CoreLogService) {
  }

  public ngOnInit(): void {
    console.debug("--- sot-loaderdialog ngOnInit")
    this.PushChanges();
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-loaderdialog ngOnDestroy")
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("LoaderDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

}
